
<template>
  <div class="refund-request-form">
    <div class="row refund-request-row no-gutters">
      <div class="col-md-6 refund-left">
        <div class="refund-reason-select-wrapper px-1">
          <select
            class="custom-select pr-1"
            v-model="localForm.type"
            @change="update"
          >
            <option value="" disabled selected>-- Please select an option --</option>

            <option :value="option.value" v-for="(option, index) in computedRequestOptions" :key="index">{{ option.text }}</option>
          </select>
        </div>
      </div>
      <div class="refund-form-reason-input col-md-6 refund-right">
        <div class="refund-reason-desc-wrapper px-1">
          <input
            type="text"
            class="form-control refund-desc-input"
            v-model="localForm.reason"
            @input="update"
            placeholder="Reason for request"
          />
        </div>
      </div>
    </div>
    <div class="row input-error ml-1" v-if="error">
      <p class="text-danger">@{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      localForm: this.$props.form,
      requestOptions: [
        { text: 'Refund', value: 'REFUND' },
        { text: 'Partial Refund', value: 'PARTIAL_REFUND' },
        { text: 'Transfer', value: 'TRANSFER' },
        { text: 'Other Issue', value: 'OTHER' }
      ]
    };
  },
  props: {
    form: {
      type: Object,
      default: function (self) {
        return {
          reason: '',
          type: ''
        };
      }
    },
    error: {
      type: [String, undefined],
      default: undefined
    },
    currentEvent: {
      type: Object,
      required: true
    }
  },
  watch: {
    form: {
      handler: function () {
        this.localForm = this.form;
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update:form', this.form);
    }
  },
  computed: {
    computedRequestOptions(){
        // Return early if disabled_order_request_types is null or not an array
        if (!Array.isArray(this.currentEvent.disabled_order_request_types)) {
            return this.requestOptions;
        }

        return this.requestOptions.filter((option) => {
            return !this.currentEvent.disabled_order_request_types.includes(option.value);
        });
    }

  },
  mounted() {
    this.update();
  }
};
</script>
